import ReceivingPlanScreen from './index';
import CreateScreen from './create';
import DetailScreen from './detail';
import UpdateScreen from './update';

const routes = [
  {
    path: '/receiving/plan',
    component: ReceivingPlanScreen,
    action: ['read_only', 'manage'],
    service: 'nvo.wms.receiving',
    params: {},
  },
  {
    path: '/receiving/plan/create',
    component: CreateScreen,
    action: ['manage'],
    service: 'nvo.wms.receiving',
  },
  {
    path: '/receiving/plan/:id',
    component: DetailScreen,
    action: ['read_only', 'manage'],
    service: 'nvo.wms.receiving',
  },
  {
    path: '/receiving/plan/:id/update',
    component: UpdateScreen,
    action: ['manage'],
    service: 'nvo.wms.receiving',
  },
];

export default routes;
